import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import TableBody from "@mui/material/TableBody";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";
import React, {useState} from "react";
import CreateIcon from "@mui/icons-material/Create";
import AddIcon from "@mui/icons-material/Add";
import {ICharArmor} from "../../_interfaces/ICharArmor";
import {s_char, s_char_armor} from "../../_signals/s_char";
import ArmorEdit from "./ArmorEdit";
import ArmorAdd from "./ArmorAdd";
import {useSignals} from "@preact/signals-react/runtime";


function Armor() {
    useSignals()
    const [edit, setEdit] = useState('')
    const [add, setAdd] = useState(false)

    const armorRow = (row: ICharArmor) => {
        return <TableRow key={row.id}>
            <TableCell style={{width: '84%'}}>
                <div>{row.name}</div>
                {row.wear ? <div>getragen</div> : null}
                {row.descr ? <div style={{fontStyle: 'italic'}}>Bem: {row.descr}</div> : null}
            </TableCell>
            <TableCell style={{width: '15%'}}>
                {row.pr+row.pr_mod}/{row.mr+row.mr_mod}
                {row.ini+row.ini_mod < 0 ? ' Ini-Malus ' + row.ini+row.ini_mod : ''}
            </TableCell>
            <TableCell style={{width: '1%', paddingRight: 0}}>
                <Button className={'btn'} id="post" onClick={() => setEdit(row.id)}>
                    <CreateIcon/>
                </Button>
            </TableCell>
        </TableRow>
    }



    return <Paper style={{overflowX: 'auto', marginTop: "14px"}}>
        <h3 style={{margin: "5px"}}>Rüstung <AddIcon onClick={() => setAdd(true)}/></h3>
        {s_char.value.name !== '' ?
            <TableContainer style={{maxHeight: 185}}>
                <Table stickyHeader style={{width: '100%'}}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Was</TableCell>
                            <TableCell>Werte</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>{s_char_armor.value.map((row) => armorRow(row))}</TableBody>
                </Table>
            </TableContainer> : null}
        <ArmorEdit edit={edit} isOpen={setEdit}></ArmorEdit>
        <ArmorAdd add={add} isOpen={setAdd}></ArmorAdd>
    </Paper>

}

export default  Armor